<template>
  <div id="content-container">
    <SupplyIndex :condition="{ type: 2 }"></SupplyIndex>
  </div>
</template>

<script>
import SupplyIndex from './index.vue'

export default {
  components: {
    SupplyIndex,
  },
}
</script>